const heb = () => {
    return {
        share: "שתף",
        share_book_title: "שתף ספר MeBook"
    };
};

export default heb;
